module.exports = __webpack_public_path__ + "img/game02.b3cbf421.png";